<div class="page-wrapper chiller-theme toggled">
  <main class="page-content">
    <div class="bgColor">
      <div class="container-fluid">

        <!-- Header -->
        <div class="row" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle">Foreign Colleges</p>
          </div>
          <div class="col-md-6 text-end">
            <p class="adminName d-inline-block">
              {{ adminName }}
              <img
                width="30px"
                height="30px"
                style="margin-left: 0.5em;"
                src="assets/tenant-avatar.jpg"
                class="rounded-circle"
              />
            </p>
          </div>
        </div>

        <!-- Add College Button + Search -->
        <div class="row mb-3">
          <div class="col-md-3">
            <button type="button"
                    class="btn btn-primary addCourseBtn"
                    (click)="openAdd()">
              <i class="fa fa-plus"></i> Add College
            </button>
          </div>
          <div class="col-md-6 offset-md-3 text-end">
            <div class="search-box" style="display:inline-flex; align-items:center; gap:8px;">
              <i class="fa fa-search search-icon"></i>
              <input type="text"
                     placeholder="Search Colleges..."
                     [(ngModel)]="collegeSearchText"
                     (input)="onCollegeFilterChanged()" />
              <i *ngIf="collegeSearchText"
                 class="fa fa-times clear-icon"
                 style="cursor:pointer"
                 (click)="clearCollegeSearch()"></i>
            </div>
          </div>
        </div>

        <!-- Colleges Grid -->
        <div class="ag-theme-alpine custom-grid">
          <ag-grid-angular
            class="ag-theme-alpine custom-grid responsive-ag-grid"
            [rowData]="colleges"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            rowSelection="single"
            [pagination]="true"
            [paginationPageSize]="20"
            [rowHeight]="45"
            (gridReady)="onCollegeGridReady($event)">
          </ag-grid-angular>
        </div>

        <!-- Image Preview Modal -->
        <div class="backdrop" *ngIf="previewImage" (click)="closeImagePreview()"></div>
        <div class="modal" *ngIf="previewImage" (click)="closeImagePreview()">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content p-3">
              <img [src]="previewImage" class="img-fluid rounded">
            </div>
          </div>
        </div>

        <!-- Add / Edit College Popup Modal -->
        <div class="backdrop" [ngStyle]="{'display':display}"></div>
        <div class="modal" [ngStyle]="{'display':display}">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                {{ editingId ? 'Edit College' : 'Add College' }}
                <button type="button" class="close" (click)="onCloseHandled()">
                  <span>&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form [formGroup]="collegeForm" (ngSubmit)="addCollege()">

                  <!-- Country -->
                  <label>Select Country</label>
                  <select class="form-control"
                          formControlName="country_id"
                          (change)="onCountryChange($event.target.value)">
                    <option value="">-- Select Country --</option>
                    <option *ngFor="let c of countries" [value]="c.id">{{ c.country }}</option>
                  </select>

                  <!-- Course -->
                  <label class="mt-2">Select Course</label>
                  <select class="form-control"
                          formControlName="foreign_course_id"
                          [disabled]="courses.length === 0">
                    <option value="">-- Select Course --</option>
                    <option *ngFor="let crs of courses" [value]="crs.id">{{ crs.course_name }}</option>
                  </select>

                  <!-- College Name -->
                  <label class="mt-2">College Name</label>
                  <input type="text" class="form-control" formControlName="college_name">

                  <!-- Description -->
                  <label class="mt-2">Description</label>
                  <textarea class="form-control scrollable-textarea"
                            formControlName="description"
                            rows="6"
                            placeholder="Enter detailed description..."></textarea>

                  <!-- Address -->
                  <label class="mt-2">Address</label>
                  <textarea class="form-control scrollable-textarea"
                            formControlName="address"
                            rows="5"
                            placeholder="Enter full address..."></textarea>

                  <!-- Hint -->
                  <label class="mt-2">Hint</label>
                  <textarea class="form-control scrollable-textarea"
                            formControlName="hint"
                            rows="4"
                            placeholder="Add hint or note..."></textarea>

                  <!-- College Image -->
                  <label class="mt-2">College Image</label>
                  <input type="file" class="form-control" (change)="onFileSelected($event)">
                  <img *ngIf="selectedImage"
                       [src]="selectedImage"
                       width="100" height="100"
                       class="mt-2 rounded-circle border"/>

                  <!-- Eligible -->
                  <label class="mt-2">Eligible</label>
                  <select class="form-control" formControlName="smscap_eligible">
                    <option [value]="1">Yes</option>
                    <option [value]="0">No</option>
                  </select>

                  <!-- Submit -->
                  <div class="mt-3 text-end">
                    <button type="button" class="btn btn-secondary me-2" (click)="onCloseHandled()">Cancel</button>
                    <button type="submit" class="btn" [ngClass]="editingId ? 'btn-primary' : 'btn-success'">
                      {{ editingId ? 'Save Changes' : 'Add College' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </main>
</div>
